enum StatusChangeDirection {
  BACKWARD = 'BACKWARD',
  FORWARD = 'FORWARD',
}

export default StatusChangeDirection;
